<template>
    <div class="controls-box">
        <div class="controls">
            <!-- Redial -->
            <img src="/traveller-ui/static/traveller/img/call.png"
                v-if="redialVisible && redialEnabled" @click="redialCall" :title="this.$t('voip.phone.make_call')" />
            <img src="/traveller-ui/static/traveller/img/call.png"
                v-if="redialVisible && !redialEnabled" class="disabled" />
            <!-- Mute / Unmute -->
            <img :src="muteButtonImage" v-if="muteVisible" @click="toggleMute" :title="muteButtonTooltip" />
            <!-- Disconnect -->
            <img src="/traveller-ui/static/traveller/img/end-call.png"
                v-if="disconnectVisible && disconnectEnabled" @click="endCall" :title="this.$t('voip.phone.disconnect')" />
            <img src="/traveller-ui/static/traveller/img/end-call.png"
                v-if="disconnectVisible && !disconnectEnabled" style="cursor: default;" />
        </div>
    </div>
</template>

<script>
import phone from '@/store/dispatching/phone';

export default {
    name: 'PhoneButtons',
    data: function() {
        return {
            redialVisible: false,
            muteVisible: false,
            disconnectVisible: false,
            disconnectEnabled: false
        };
    },
    beforeCreate: function() {
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
    },
    computed: {
        muteButtonImage() {
            if (this.$store.state.phone.phoneState.isMuted === true) {
                return '/traveller-ui/static/traveller/img/unmute.png';
            }
            return '/traveller-ui/static/traveller/img/mute.png';
        },
        muteButtonTooltip() {
            if (this.$store.state.phone.phoneState.isMuted === true) {
                return this.$t('voip.phone.unmute');
            }
            return this.$t('voip.phone.mute');
        },
        phoneStatus() {
            return this.$store.state.phone.phoneState.status;
        },
        redialEnabled() {
            const recipient = this.$store.state.phone.phoneState.recipient;
            if (recipient && recipient.length > 0) {
                if (Array.isArray(recipient)) {
                    for (const r of recipient) {
                        if (this.$store.state.phone.phonebook[r] &&
                            this.$store.state.phone.phonebook[r].status == 'online') {
                            return true;
                        }
                    }
                } else if (this.$store.state.phone.phonebook[recipient] &&
                    this.$store.state.phone.phonebook[recipient].status == 'online') {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        phoneStatus(s) {
            // Set some defaults in the beginning to lessen repetition.
            this.redialVisible = false;
            this.muteVisible = false;
            this.disconnectVisible = false;
            this.disconnectEnabled = false;

            switch (s) {
                case 'connected':
                case 'registered':
                case 'disconnected':
                case 'unregistered':
                case 'unconfigured':
                    break;
                case 'calling':
                    this.disconnectVisible = true;
                    setTimeout(() => { this.disconnectEnabled = true; }, 1000);
                    break;
                case 'call_connected':
                    this.muteVisible = true;
                    this.disconnectVisible = true;
                    this.disconnectEnabled = true;
                    break;
                case 'group_call_setup':
                case 'call_ended':
                case 'call_error':
                    this.redialVisible = true;
            }
        }
    },
    methods: {
        redialCall() {
            if (this.$store.state.phone.phoneState.recipient) {
                this.$store.commit(
                    this.$store.state.phone.phoneState.isGroupCall ? 'phone/requestGroupCall' : 'phone/requestIndividualCall',
                    this.$store.state.phone.phoneState.recipient
                );
            }
        },
        endCall() {
            this.$store.commit('phone/requestEndCall');
        },
        toggleMute() {
            if (this.$store.state.phone.phoneState.isMuted === true) {
                this.$store.commit('phone/requestUnmute');
            } else {
                this.$store.commit('phone/requestMute');
            }
        }
    }
}
</script>